import { createSelector } from 'redux-bundler';
import { arcgisToGeoJSON, geojsonToArcGIS } from '@esri/arcgis-to-geojson-utils';

function formatUrl(options){
  let url = `${options.root}/identify?`;
  const params = [];
  for(var key in options){
    if(key !== 'root') {
      if(key==='Layers') {
        params.push(key + '=' + (options[key].toString()).split(':')[1])
      }else{
        params.push(key + '=' + options[key].toString())
      }
    }    
  }
  url += params.join('&');
  url = url +'&f=pjson&returnGeometry=true'
  return url;
}

/// MapService https://developers.arcgis.com/rest/services-reference/identify-map-service-.htm
/// FeatureService
export default {
  name: 'esriIdent',

  getReducer(){
    const initialState = {
      shouldRegister: true,
    }

    return (state = initialState, { type, payload }) => {
      switch(type){
        case 'ESRI_IDENT_REGISTERED':
          return Object.assign({}, state, payload);
        default:
          return state;
      }
    }
  },

  doEsriIdentRegister: () => ({dispatch, store}) => {
    dispatch({type: 'ESRI_IDENT_REGISTERED', payload: { shouldRegister: false }});
    store.doIdentifyAddCollection({
      onIdentify: store.doEsriIdentFire
    })
  },

  doEsriIdentFire: (callback) => ({dispatch, store, anonGet}) => {
    const coords = store.selectIdentifyCoordinates();
    const visibleLayers = store.selectVisibleEsriLayers();
    const resolution = store.selectResolution();
    const zoom =Math.round(Math.log(156543.03390625) * Math.LOG2E  - Math.log(resolution) * Math.LOG2E);
    const urlCalls = visibleLayers.length;
    let compUrl = 0;
    if(!visibleLayers.length) return callback(null, []);
    const finResult=[];
    const cb = function(data) {
      compUrl= compUrl+1;
      if(compUrl === urlCalls) {
        finResult.push(data)
        callback(null,finResult)
      }else{
        finResult.push(data)
      }
    };
    const intCB = (objResult, displayName) => (err, response, body) => {
      if(err || response.statusCode !== 200){
        callback({err: err, response: response});
      }else{
        const data = JSON.parse(body)
        
        let result = {
          'type': 'FeatureCollection',
          'features':[]
        };
        //console.log(data)
        if(data.results && data.results.length >0) {

          for(let j=0;j<data.results.length;j++) {
            const tmpJSON ={
              'type': 'Feature',
              'geometry': {
                'type': 'Polygon',
                'coordinates': []
              },
              'properties': {}
            }
            const currRes = data.results[j];

            const resgjson= arcgisToGeoJSON(currRes.geometry);
            tmpJSON.geometry=resgjson
            tmpJSON.properties=currRes.attributes;
            tmpJSON.properties.layerName=currRes.layerName
            result.features.push(tmpJSON);
          }
        }else{
          result= null
        }
        objResult.result={[displayName]:result}
        cb(objResult)
      }

      
    }
    for(let i=0;i<visibleLayers.length;i++) {
      
      
      const lyr = visibleLayers[i].layer;
      const obj =Object.assign({}, {
        'dataset':lyr.dsName,
        'result':{}
      });
      let displayName =lyr.displayName.replace(/&/g, 'and')
      if(lyr.parent) {
       displayName =`${lyr.parent.displayName} ${(lyr.displayName).replace(/&/g, 'and')}`
      }
      const params = {
        root: lyr.url,
        layers: `${lyr.layerList}`,
        mapExtent: (store.selectMapExtent()).join(','),
        imageDisplay: (store.selectMapImageDisplay()).join(',')
      }
      if(typeof coords[0] === 'number'){
        params.geometryType=`esriGeometryPoint&geometry={x: ${coords[0]}, y: ${coords[1]}}`;
        params.tolerance = zoom;
      }else{
        const gjson = {
          'type': 'FeatureCollection',
          'features':[
            {
              'type': 'Feature',
              'geometry': {
                'type': 'Polygon',
                'coordinates': coords
              },
              'properties': {}
            }]
        };
        const esriCoords = geojsonToArcGIS(gjson);
        params.geometryType=`esriGeometryPolygon&geometry=${JSON.stringify(esriCoords[0].geometry)}`;
        params.tolerance = 2;
      }
      const url = formatUrl(params);
      anonGet(url, intCB(obj, displayName));
    }
    
    
    

    
    // const url = formatUrl(params);
    // anonGet(url, (err, response, body) => {
    //   if(err || response.statusCode !== 200){
    //     callback({err: err, response: response});
    //   }else{
        
    //     const data = JSON.parse(body)
    //     data.pop();
    //     callback(null, data);
    //   }
    // })
  },
  // doEsriIdentFire: (callback) => ({dispatch, store, anonGet}) => {
  //   const coords = store.selectIdentifyCoordinates();
  //   const visibleLayers = store.selectVisibleEsriLayers();
  //   const resolution = store.selectResolution();
  //   let urlCalls = 0;
  //   let compUrl = 0;
  //   if(!visibleLayers.length) return callback(null, []);
  //   const finResult=[];
  //   const cb = function(data) {
  //     compUrl= compUrl+1;
  //     if(compUrl === urlCalls) {
  //       finResult.push(data)
  //       console.log(finResult)
  //       callback(null,finResult)
  //     }else{
  //       finResult.push(data)
  //     }
  //   };
  //   const intCB = (objResult, dataset, displayName) => (err, response, body) => {
  //     if(err || response.statusCode !== 200){
  //       callback({err: err, response: response});
  //     }else{
  //       const data = JSON.parse(body)
        
  //       let result = {
  //         'type': 'FeatureCollection',
  //         'features':[]
  //       };
  //       //console.log(data)
  //       // if(data.results && data.results.length >0) {

  //       //   for(let j=0;j<data.results.length;j++) {
  //       //     const tmpJSON ={
  //       //       'type': 'Feature',
  //       //       'geometry': {
  //       //         'type': 'Polygon',
  //       //         'coordinates': []
  //       //       },
  //       //       'properties': {}
  //       //     }
  //       //     const currRes = data.results[j];
  //       //     if(currRes.features.length>0)
  //       //     console.log(data)
  //       //     // const resgjson= arcgisToGeoJSON(currRes.geometry);
  //       //     // tmpJSON.geometry=resgjson
  //       //     // tmpJSON.properties=currRes.attributes;
  //       //     // tmpJSON.properties.layerName= currRes.layerName;
            
  //       //     // result.features.push(tmpJSON);
  //       //   }
  //       // }else{
  //       //   result= null
  //       // }
  //       if()
  //       objResult.result=Object.assign(objResult.result ,{[displayName]:data})
  //     }

  //     cb(objResult)
  //   }
  //   for(let i=0;i<visibleLayers.length;i++) {
  //     const lyr = visibleLayers[i].layer;
  //     const lyrArr = lyr.layerList.split(',');
  //     urlCalls = urlCalls + lyrArr.length

  //   }
  //   for(let i=0;i<visibleLayers.length;i++) {
      
      
  //     const lyr = visibleLayers[i].layer;
  //     const lyrArr = lyr.layerList.split(',');
  //     const obj =Object.assign({}, {
  //       'dataset':lyr.dsName,
  //       'result':{}
  //     });
      
  //     for(let j=0; j<lyrArr.length; j++ ) {
  //       let displayName =`${(lyr.displayName).replace(/&/g, 'and')} Layer Id ${lyrArr[j]}`
  //       if(lyr.parent) {
  //         displayName =`${lyr.parent.displayName} ${(lyr.displayName).replace(/&/g, 'and')} Layer Id ${lyrArr[j]}`;
  //       }
  //       const params = {
  //         root: `${lyr.url}/${lyrArr[j]}/query?outFields=*&returnGeometry=true&`,
          
  //       }
  //       if(typeof coords[0] === 'number'){
  //         params.geometryType=`esriGeometryPoint&geometry={x: ${coords[0]}, y: ${coords[1]}}`;
  //         params.tolerance = 2;
  //         params.spatialRel='esriSpatialRelRelation'
  //       }else{
  //         const gjson = {
  //           'type': 'FeatureCollection',
  //           'features':[
  //             {
  //               'type': 'Feature',
  //               'geometry': {
  //                 'type': 'Polygon',
  //                 'coordinates': coords
  //               },
  //               'properties': {}
  //             }]
  //         };
  //         const esriCoords = geojsonToArcGIS(gjson);
  //         params.geometryType=`esriGeometryPolygon&geometry=${JSON.stringify(esriCoords[0].geometry)}`;
  //         params.tolerance = 2;
  //       }
  //       const url = formatUrl(params);
  //       anonGet(url, intCB(obj, displayName));
  //     }
      
  //   }
    
    
    

    
  //   // const url = formatUrl(params);
  //   // anonGet(url, (err, response, body) => {
  //   //   if(err || response.statusCode !== 200){
  //   //     callback({err: err, response: response});
  //   //   }else{
        
  //   //     const data = JSON.parse(body)
  //   //     data.pop();
  //   //     callback(null, data);
  //   //   }
  //   // })
  // },
  selectVisibleEsriLayers: createSelector(
    'selectLayers',
    (layers) => {
      const esriLayers = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].visible && layers[key].geometryType==='SERVICE' 
        && (layers[key].type.indexOf('Arc') !== -1)
        ) {
          esriLayers.push({
              layer:layers[key],
            });
        } 
      })
      return esriLayers;
    }
  ),
  reactEsriIdentShouldRegister: (state) => {
    if(state.esriIdent.shouldRegister) return { actionCreator: 'doEsriIdentRegister' };
  }
}